import React, { useCallback } from 'react';
import { Box, Preloader } from '@common-fe/common-fe';

import Permissions from '@/common/permissions';
import ROUTES from '@/common/routes';
import { Access } from '@/modules/core/components';
import Topbar from '@/modules/core/components/Topbar/Topbar';
import { useHistory } from '@/modules/core/hooks';
import { PayoutDefinitionSetupContainer } from '@/modules/ProcessingDefinition/PayoutDefinition/PayoutDefinitionSetup';
import { TopbarSaveButton } from '@/modules/ProcessingDefinition/PayoutDefinition/PayoutDefinitionSetup/widgets/FinalSetup';
import { useAuthStore } from '@/modules/user/stores';
import theme from '@/styles/theme';

const PayoutDefinitionPage = () => {
  const { user } = useAuthStore();
  const history = useHistory();
  const goHome = useCallback(() => history.push(ROUTES.HOME), [history]);

  if (!user) {
    return (
      <Box width="100%" justify="center" align="center">
        <Preloader />
      </Box>
    );
  }

  return (
    <Access
      accessRequirements={[
        { permission: Permissions.SET_UP_PROCESSING_DEFINITION },
        { permission: Permissions.MANAGE_PAYOUT_DEFINITION },
      ]}
      accessDeniedAction={goHome}
    >
      <Box width="100%" height="fit-content">
        <Topbar>
          <TopbarSaveButton />
        </Topbar>
        <Box align="center" pad={{ bottom: 'spacing72' }}>
          <Box width={theme.defaultContentWidth}>
            <PayoutDefinitionSetupContainer />
          </Box>
        </Box>
      </Box>
    </Access>
  );
};

export default PayoutDefinitionPage;
